export default __webpack_public_path__ + "fill.asset.0c89b6128331ac7a4566747b3d2fdd55.svg";